'use client';

import { useSyncExternalStore } from 'react';
import { Waveform, type WaveformScale, type WaveformShape, type WaveformTone } from './Waveform';
import { ZERO_LEVELS, type AudioLevelStore } from '../../lib/audioLevelStore';

interface LiveWaveformProps {
  store: AudioLevelStore;
  isActive: boolean;
  /** Passed straight through to `Waveform`; defaults to the recording size. */
  scale?: WaveformScale;
  tone?: WaveformTone;
  shape?: WaveformShape;
}

const getServerSnapshot = () => ZERO_LEVELS;

/**
 * The ONLY component that subscribes to live mic levels. Level frames arrive
 * at display rate; subscribing here (instead of lifting the frames into the
 * session root's React state) confines the per-frame re-render to this leaf
 * (2026-07-18 primetime audit CRITICAL).
 */
export function LiveWaveform({ store, isActive, scale, tone, shape }: LiveWaveformProps) {
  const levels = useSyncExternalStore(store.subscribe, store.getSnapshot, getServerSnapshot);
  return <Waveform levels={[...levels]} isActive={isActive} scale={scale} tone={tone} shape={shape} />;
}
